
import { Vue, Component, Ref, Prop } from 'vue-property-decorator';
import InvoiceUpload from './invoiceUpload.vue';
import SelectInvoiceModal from './selectInvoiceModal.vue';
import { FormModel } from 'ant-design-vue';
import InvoiceService from '@/services/invoice.service';
import lazyInject from '@/di';
import UploadFile from '@/views/operation/components/uploudFile.vue';
import { validateTaxNumber } from '@/common/utils';

@Component({
  components: {
    InvoiceUpload,
    'select-invoice-modal': SelectInvoiceModal,
    UploadFile,
  },
})
export default class InvoiceApply extends Vue {
  visible = false;
  @Prop({ default: '' })
  kaId!: any;

  @Prop()
  typeOrder!: string;

  @Ref('selectInvoiceModal')
  selectInvoiceModal!: SelectInvoiceModal;

  @lazyInject(InvoiceService)
  protected invoiceService!: InvoiceService;

  @Ref('formRef')
  formRef!: FormModel;

  @Prop({ default: '' })
  formData!: any;

  @Prop({ default: '' })
  rawId!: any;

  uploadUrl = 'https://jsonplaceholder.typicode.com/posts/';
  uploadList = [];

  form: any = {
    title: '',
    tax_no: '',
    address: '',
    tel: '',
    bank: '',
    account: '',
    email: '',
    phone: '',
    invoice_category: '',
    category: '2',
  };

  titleList: any[] = [];

  licenseData: any = {};

  rules = {
    title: [{ required: true, message: '请输入发票抬头' }],
    tax_no: [{ required: true, validator: this.taxNumberValidator }],
    email: [{ required: true, validator: this.emailValidator }],
    phone: [{ required: true, message: '请输入联系电话' }],
  };

  // 普票
  generalTicket = {
    title: [{ required: true, message: '请输入发票抬头' }],
    tax_no: [{ required: true, validator: this.taxNumberValidator }],
    email: [{ required: true, validator: this.emailValidator }],
    phone: [{ required: true, message: '请输入联系电话' }],
  };
  // 专票
  specialTicket = {
    title: [{ required: true, message: '请输入发票抬头' }],
    tax_no: [{ required: true, validator: this.taxNumberValidator }],
    address: [{ required: true, message: '请输入注册地址' }],
    tel: [{ required: true, message: '请输入注册电话' }],
    bank: [{ required: true, message: '请输入开户银行' }],
    account: [{ required: true, message: '请输入银行账号' }],
    email: [{ required: true, validator: this.emailValidator }],
    phone: [{ required: true, message: '请输入联系电话' }],
    license: [{ required: true, validator: this.licenseValidator }],
  };

  licenseValidator(rule: any, value: any, callback: any) {
    if (!this.form.license) {
      callback(new Error('请上传一般纳税人资格证明'));
    } else {
      callback();
    }
  }
  emailValidator(rule: any, value: any, callback: any) {
    const strictEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!value) {
      callback(new Error('请输入邮箱'));
    } else if (!strictEmailRegex.test(value)) {
      callback(new Error('请输入正确的邮箱地址'));
    } else {
      callback();
    }
  }

  taxNumberValidator(rule: any, value: any, callback: any) {
    if (!value) {
      callback(new Error('请输入税号'));
    } else if (!validateTaxNumber(value)) {
      callback(new Error('请输入正确的税号'));
    } else {
      callback();
    }
  }

  handleChange(type: string, value: any) {
    this.form[type] = value;
    if (this.form.invoice_category && this.form.category) {
      const title = this.titleList.find(
        (item: any) =>
          String(item.invoice_category) === this.form.invoice_category &&
          String(item.category) === this.form.category &&
          item.is_default === 1,
      );
      if (title) {
        this.changeInvoice(title);
      } else {
        this.form.title = '';
        this.form.tax_no = '';
        this.form.address = '';
        this.form.tel = '';
        this.form.bank = '';
        this.form.account = '';
        this.form.email = '';
        this.form.phone = '';
      }
    }
    if (this.form.invoice_category === '1') {
      this.rules = this.generalTicket;
      this.formRef.clearValidate([]);
    } else {
      this.rules = this.specialTicket;
      this.formRef.clearValidate([]);
    }
  }

  async handleSubmit() {
    // console.log(this.form);
    this.formRef.validate((valid) => {
      if (valid) {
        this.poshInvoiceApply();
      }
    });
  }

  async poshInvoiceApply() {
    const _data = Object.assign({}, this.formData, this.form, {
      raw_id: this.rawId,
    });
    _data.buyer_category = _data.category;
    delete _data.category;
    _data.shop_ids = _data.shop_id;
    delete _data.shop_id;
    let res: any = null;
    if (this.typeOrder === '1') {
      res = await this.invoiceService.invoiceApply(_data);
    } else {
      delete _data.raw_id;
      res = await this.invoiceService.applyInsuranceInvoice(_data);
    }
    // applyInsuranceInvoice
    if (res) {
      this.$message.success('提交成功');
      this.handleCancel();
      this.$emit('refresh');
    }
  }

  popupScroll() {
    // console.log('popupScroll');
  }

  changeLicense(val: any) {
    this.licenseData = val;
    this.form.license = val.id;
  }

  async selectInvoice() {
    this.selectInvoiceModal.init(this.titleList, this.form.invoice_category);
  }

  changeInvoice(item: any) {
    // console.log(item);
    const { info } = item;
    this.form.title = info.title;
    this.form.tax_no = info.tax_no;
    this.form.address = info.address;
    this.form.tel = info.tel;
    this.form.bank = info.bank;
    this.form.account = info.account;
    this.form.email = info.email;
    this.form.license = info.license;
    this.form.phone = info.phone;
    this.form.invoice_category = String(item.invoice_category);
    this.form.category = String(item.category);
    if (info.license) {
      this.licenseData = {
        id: info.license,
        url: info.license_url,
      };
    }
  }

  handleCancel() {
    this.visible = false;
    this.formRef.resetFields();
  }

  async init() {
    this.licenseData = {
      id: '',
      url: '',
    };
    const res = await this.invoiceService.getInvoiceBuyerList({
      ka_id: this.kaId,
    });
    this.titleList = res;
    this.visible = true;
  }
}
